(function ($) {
  pcgProductV1 = {
    formatter: $('.pcg-product-v1')
  };

  Drupal.behaviors.pcgProductV1 = {
    get: function (key) {
      return pcgProductV1[key];
    },

    set: function (key, val) {
      pcgProductV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);
        // The brand needs a way to "globally" adjust the product titles width.
        // The main problem is that implementing any "global" fix will apply to 
        // all product titles, including the ones that already have line breaks (<br>) 
        // in it and that could make some product titles (with <br>) look worse. 
        // TODO: For any "global" solution we'll need to do a clean up of the existent product 
        // titles (remove all <br> from product titles) and adjust the product titles 
        // via CSS only.
        // WORKAROUND: Look for product titles without any <br> tags in it and override its 
        // default max-width (set to 160px bellow) while ignoring any product title 
        // that contains one or more <br> tags in it.
        var prodTitle = thisFormatter.find('.product .product-info .product-title'),
          prodTitleHtml = prodTitle.find('a').html(),
          prodTitleBr = prodTitle.find('a br'),
          maxWidth = '160px'; // Maybe this can be set through CMS in a field

        if (prodTitleBr.length === 0) {
          prodTitle.css({ 'max-width': maxWidth });
        }
      });
    }
  };
})(jQuery);
